export enum ReferenceType {
	STUDY = 'study',
	UNIVERSITY = 'university',
	SCHOLARSHIP = 'scholarship'
}
